import React from 'react';
import { Popover, IconButton } from '@material-ui/core';

export function EePopover(props: any) {
  const { open, title, onClose, children, width = 270, anchorEl } = props;
  return (
    <Popover
      id="simple-popover"
      open={open}
      anchorEl={anchorEl.current}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
    >
      <div
        className="p-2 position-relative"
        style={{ borderLeft: '6px solid #5d7599', maxWidth: width }}
      >
        <IconButton
          onClick={onClose}
          style={{ position: 'absolute', top: 0, right: 0 }}
        >
          <i className="material-icons" style={{ fontSize: 14 }}>
            highlight_off
          </i>
        </IconButton>
        <p className="fs-16 mb-0">{title}</p>
        <div className="fs-14 mb-0" style={{ color: '#676767' }}>
          {children}
        </div>
      </div>
    </Popover>
  );
}
